<template>
  <div class="applicant-detail">
    <div class="mb-x1" v-if="snsType === 'twitter'">
      {{ 'フォロワー:' }}
      {{ formatNumber(applicant.followersCount) }}
    </div>
    <div class="mb-x1" v-if="snsType === 'twitter'">
      {{ 'ポスト:' }}
      {{ formatNumber(applicant.tweetsCount) }}
    </div>
    <div class="mb-x1">
      {{ '応募数:' }}
      {{ formatNumber(applicant.postsCount) }}
    </div>
    <div class="mb-x1">
      {{ '累計参加数:' }}
      {{ formatNumber(applicant.totalCampaignEntryCount) }}
    </div>
    <div class="mb-x1">
      {{ '累計当選数:' }}
      {{ formatNumber(applicant.totalCampaignWinningCount) }}
    </div>
    <!-- Twitterの場合-->
    <div class="mt-x2" v-if="snsType === 'twitter'" layout>
      <!-- Twitterで確認-->
      <el-tooltip :enterable="false" placement="top" content="Xで確認">
        <template v-if="applicant.post.postType === 'retweet'"
          ><a :href="'https://x.com/' + applicant.screenName" target="_new">
            <el-button class="el-button--icon" type="default"><i class="mdi mdi-open-in-new"></i></el-button></a
        ></template>
        <template v-else
          ><a :href="'https://x.com/' + applicant.screenName + '/status/' + applicant.post.id" target="_new">
            <el-button class="el-button--icon" type="default"><i class="mdi mdi-open-in-new"></i></el-button></a
        ></template>
      </el-tooltip>
      <!-- 候補者フラグ-->
      <el-tooltip
        :enterable="false"
        v-if="applicant.isNg === 1 && applicant.isCandidate === 0"
        placement="top"
        :content="'NGアカウント'"
      >
        <div class="ml-button">
          <el-button class="el-button--icon" type="default" :disabled="true"><i class="mdi mdi-star"></i></el-button>
        </div>
      </el-tooltip>
      <el-tooltip
        :enterable="false"
        v-else
        placement="top"
        :content="applicant.isCandidate === 1 ? '候補者を解除' : '候補者に追加'"
      >
        <div class="ml-button">
          <el-button
            class="is-candidate-button el-button--icon"
            :type="applicant.isCandidate === 1 ? 'primary' : 'default'"
            :disabled="isEndContract"
            @click="updateFlg('candidate')"
            ><i class="mdi mdi-star"></i
          ></el-button>
        </div>
      </el-tooltip>
      <!-- 当選者フラグ-->
      <el-tooltip
        :enterable="false"
        v-if="applicant.isNg === 1 && applicant.isWinner === 0"
        placement="top"
        content="NGアカウント"
      >
        <div class="ml-button">
          <el-button class="el-button--icon" type="default" :disabled="true"><i class="mdi mdi-trophy"></i></el-button>
        </div>
      </el-tooltip>
      <el-tooltip :enterable="false" v-else placement="top" :content="winnerTooltipContent()">
        <div class="ml-button">
          <el-button
            class="is-winner-button el-button--icon"
            :type="applicant.isWinner === 1 ? 'primary' : 'default'"
            :disabled="isEndContract || isDmSending"
            @click="updateFlg('winner')"
            ><i class="mdi mdi-trophy"></i
          ></el-button>
        </div>
      </el-tooltip>
      <!-- 回答者フラグ-->
      <el-tooltip
        :enterable="false"
        v-if="applicant.isNg === 1 && applicant.isResponder === 0"
        placement="top"
        content="NGアカウント"
      >
        <div class="ml-button">
          <el-button class="el-button--icon" type="default" :disabled="true"
            ><i class="mdi mdi-clipboard-check"></i
          ></el-button>
        </div>
      </el-tooltip>
      <el-tooltip
        :enterable="false"
        v-else
        placement="top"
        :content="applicant.isResponder === 1 ? '回答者を解除' : '回答者に追加'"
      >
        <div class="ml-button">
          <el-button
            class="is-responder-button el-button--icon"
            :type="applicant.isResponder === 1 ? 'primary' : 'default'"
            :disabled="isEndContract"
            @click="updateFlg('responder')"
            ><i class="mdi mdi-clipboard-check"></i
          ></el-button>
        </div>
      </el-tooltip>
      <!-- メッセージ履歴-->
      <div class="ml-button">
        <IconButtonWithBadge
          name="message-text"
          tooltip="メッセージ履歴"
          :disabled="isEndContract || !applicant.messagesCount"
          :show-badge="applicant.messagesCount > 0"
          badge-variant="active"
          @click="openMessageHistory(applicant.id)"
        >
          <template #badge>{{ formatNumber(applicant.messagesCount) }}</template>
        </IconButtonWithBadge>
      </div>
      <!-- NGアカウント追加/解除-->
      <el-tooltip :enterable="false" placement="top" :content="ngTooltipContent">
        <div class="ml-button">
          <el-button class="el-button--icon" :type="applicant.isNg === 1 ? 'primary' : 'default'" @click="changeNg()"
            ><i class="mdi mdi-cancel"></i
          ></el-button>
        </div>
      </el-tooltip>
    </div>
    <!-- Instagramの場合-->
    <div class="mt-x2" v-else-if="snsType === 'instagram'" layout>
      <!-- Instagramで確認-->
      <el-tooltip :enterable="false" placement="top" content="Instagramで確認"
        ><a :href="applicant.post.permalink" target="_new">
          <el-button class="el-button--icon" type="default"><i class="mdi mdi-open-in-new"></i></el-button></a
      ></el-tooltip>
      <!-- フォローフラグ-->
      <el-tooltip
        :enterable="false"
        placement="top"
        :content="applicant.isFollowing === 1 ? 'フォローを解除' : 'フォローに追加'"
      >
        <div class="ml-button">
          <el-button
            class="is-follower-button el-button--icon"
            :type="applicant.isFollowing === 1 ? 'primary' : 'default'"
            :disabled="isEndContract"
            @click="updateFlg('follower')"
            ><i class="mdi mdi-account-network"></i
          ></el-button>
        </div>
      </el-tooltip>
      <!-- 候補者フラグ-->
      <el-tooltip
        :enterable="false"
        v-if="applicant.isNg === 1 && applicant.isCandidate === 0"
        placement="top"
        content="NGアカウント"
      >
        <div class="ml-button">
          <el-button class="el-button--icon" type="default" :disabled="true"><i class="mdi mdi-star"></i></el-button>
        </div>
      </el-tooltip>
      <el-tooltip
        :enterable="false"
        v-else
        placement="top"
        :content="applicant.isCandidate === 1 ? '候補者を解除' : '候補者に追加'"
      >
        <div class="ml-button">
          <el-button
            class="el-button--icon"
            :type="applicant.isCandidate === 1 ? 'primary' : 'default'"
            :disabled="isEndContract"
            @click="updateFlg('candidate')"
            ><i class="mdi mdi-star"></i
          ></el-button>
        </div>
      </el-tooltip>
      <!-- 当選者フラグ-->
      <el-tooltip
        :enterable="false"
        v-if="applicant.isNg === 1 && applicant.isWinner === 0"
        placement="top"
        content="NGアカウント"
      >
        <div class="ml-button">
          <el-button class="is-winner-button el-button--icon" type="default" :disabled="true"
            ><i class="mdi mdi-trophy"></i
          ></el-button>
        </div>
      </el-tooltip>
      <el-tooltip :enterable="false" v-else placement="top" :content="winnerTooltipContent()">
        <div class="ml-button">
          <el-button
            class="is-winner-button el-button--icon"
            :type="applicant.isWinner === 1 ? 'primary' : 'default'"
            :disabled="isEndContract || isDmSending"
            @click="updateFlg('winner')"
            ><i class="mdi mdi-trophy"></i
          ></el-button>
        </div>
      </el-tooltip>
      <!-- 回答者フラグ-->
      <el-tooltip
        :enterable="false"
        v-if="applicant.isNg === 1 && applicant.isResponder === 0"
        placement="top"
        content="NGアカウント"
      >
        <div class="ml-button">
          <el-button class="el-button--icon" type="default" :disabled="true"
            ><i class="mdi mdi-clipboard-check"></i
          ></el-button>
        </div>
      </el-tooltip>
      <el-tooltip
        :enterable="false"
        v-else
        placement="top"
        :content="applicant.isResponder === 1 ? '回答者を解除' : '回答者に追加'"
      >
        <div class="ml-button">
          <el-button
            class="is-responder-button el-button--icon"
            :type="applicant.isResponder === 1 ? 'primary' : 'default'"
            :disabled="isEndContract"
            @click="updateFlg('responder')"
            ><i class="mdi mdi-clipboard-check"></i
          ></el-button>
        </div>
      </el-tooltip>
      <!-- 当選連絡フラグ-->
      <el-tooltip
        :enterable="false"
        v-if="applicant.isNg === 1 && applicant.isWinnerContact === 0"
        placement="top"
        content="NGアカウント"
      >
        <div class="ml-button">
          <el-button class="el-button--icon" type="default" :disabled="true"
            ><i class="mdi mdi-email-check"></i
          ></el-button>
        </div>
      </el-tooltip>
      <el-tooltip
        :enterable="false"
        v-else
        placement="top"
        :content="applicant.isWinnerContact === 1 ? '当選連絡を解除' : '当選連絡に追加'"
      >
        <div class="ml-button">
          <el-button
            class="is-winner-contact-button el-button--icon"
            :type="applicant.isWinnerContact === 1 ? 'primary' : 'default'"
            :disabled="isEndContract"
            @click="updateFlg('winnerContact')"
            ><i class="mdi mdi-email-check"></i
          ></el-button>
        </div>
      </el-tooltip>
      <!-- NGアカウント追加/解除-->
      <el-tooltip :enterable="false" placement="top" :content="ngTooltipContent">
        <div class="ml-button">
          <el-button class="el-button--icon" :type="applicant.isNg === 1 ? 'primary' : 'default'" @click="changeNg()"
            ><i class="mdi mdi-cancel"></i
          ></el-button>
        </div>
      </el-tooltip>
    </div>
    <!-- TikTokの場合-->
    <div class="mt-x2" v-else-if="snsType === 'tiktok'" layout>
      <!-- TikTokで確認-->
      <el-tooltip :enterable="false" placement="top" content="TikTokで確認"
        ><a :href="'https://tiktok.com/@' + applicant.screenName" target="_new">
          <el-button class="el-button--icon" type="default"><i class="mdi mdi-open-in-new"></i></el-button></a
      ></el-tooltip>
      <!-- フォローフラグ-->
      <el-tooltip
        :enterable="false"
        placement="top"
        :content="applicant.isFollowing === 1 ? 'フォローを解除' : 'フォローに追加'"
      >
        <div class="ml-button">
          <el-button
            class="is-follower-button el-button--icon"
            :type="applicant.isFollowing === 1 ? 'primary' : 'default'"
            :disabled="isEndContract"
            @click="updateFlg('follower')"
            ><i class="mdi mdi-account-network"></i
          ></el-button>
        </div>
      </el-tooltip>
      <!-- 候補者フラグ-->
      <el-tooltip
        :enterable="false"
        v-if="applicant.isNg === 1 && applicant.isCandidate === 0"
        placement="top"
        content="NGアカウント"
      >
        <div class="ml-button">
          <el-button class="el-button--icon" type="default" :disabled="true"><i class="mdi mdi-star"></i></el-button>
        </div>
      </el-tooltip>
      <el-tooltip
        :enterable="false"
        v-else
        placement="top"
        :content="applicant.isCandidate === 1 ? '候補者を解除' : '候補者に追加'"
      >
        <div class="ml-button">
          <el-button
            class="el-button--icon"
            :type="applicant.isCandidate === 1 ? 'primary' : 'default'"
            :disabled="isEndContract"
            @click="updateFlg('candidate')"
            ><i class="mdi mdi-star"></i
          ></el-button>
        </div>
      </el-tooltip>
      <!-- 当選者フラグ-->
      <el-tooltip
        :enterable="false"
        v-if="applicant.isNg === 1 && applicant.isWinner === 0"
        placement="top"
        content="NGアカウント"
      >
        <div class="ml-button">
          <el-button class="is-winner-button el-button--icon" type="default" :disabled="true"
            ><i class="mdi mdi-trophy"></i
          ></el-button>
        </div>
      </el-tooltip>
      <el-tooltip :enterable="false" v-else placement="top" :content="winnerTooltipContent()">
        <div class="ml-button">
          <el-button
            class="is-winner-button el-button--icon"
            :type="applicant.isWinner === 1 ? 'primary' : 'default'"
            :disabled="isEndContract || isDmSending"
            @click="updateFlg('winner')"
            ><i class="mdi mdi-trophy"></i
          ></el-button>
        </div>
      </el-tooltip>
      <!-- 回答者フラグ-->
      <el-tooltip
        :enterable="false"
        v-if="applicant.isNg === 1 && applicant.isResponder === 0"
        placement="top"
        content="NGアカウント"
      >
        <div class="ml-button">
          <el-button class="el-button--icon" type="default" :disabled="true"
            ><i class="mdi mdi-clipboard-check"></i
          ></el-button>
        </div>
      </el-tooltip>
      <el-tooltip
        :enterable="false"
        v-else
        placement="top"
        :content="applicant.isResponder === 1 ? '回答者を解除' : '回答者に追加'"
      >
        <div class="ml-button">
          <el-button
            class="is-responder-button el-button--icon"
            :type="applicant.isResponder === 1 ? 'primary' : 'default'"
            :disabled="isEndContract"
            @click="updateFlg('responder')"
            ><i class="mdi mdi-clipboard-check"></i
          ></el-button>
        </div>
      </el-tooltip>
      <!-- 当選連絡フラグ-->
      <el-tooltip
        :enterable="false"
        v-if="applicant.isNg === 1 && applicant.isWinnerContact === 0"
        placement="top"
        content="NGアカウント"
      >
        <div class="ml-button">
          <el-button class="el-button--icon" type="default" :disabled="true"
            ><i class="mdi mdi-email-check"></i
          ></el-button>
        </div>
      </el-tooltip>
      <el-tooltip
        :enterable="false"
        v-else
        placement="top"
        :content="applicant.isWinnerContact === 1 ? '当選連絡を解除' : '当選連絡に追加'"
      >
        <div class="ml-button">
          <el-button
            class="is-winner-contact-button el-button--icon"
            :type="applicant.isWinnerContact === 1 ? 'primary' : 'default'"
            :disabled="isEndContract"
            @click="updateFlg('winnerContact')"
            ><i class="mdi mdi-email-check"></i
          ></el-button>
        </div>
      </el-tooltip>
      <!-- NGアカウント追加/解除-->
      <el-tooltip :enterable="false" placement="top" :content="ngTooltipContent">
        <div class="ml-button">
          <el-button class="el-button--icon" :type="applicant.isNg === 1 ? 'primary' : 'default'" @click="changeNg()"
            ><i class="mdi mdi-cancel"></i
          ></el-button>
        </div>
      </el-tooltip>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@use '@/client/assets/scss/variables.scss' as *;

.message-button {
  position: relative;
}

.badge {
  right: -4px;
  bottom: 0;
}

.ml-button {
  margin-left: $spacing-unit + 2;
}
</style>
<script lang="ts">
import { mapState } from 'pinia'
import { defineComponent, PropType } from 'vue'

import IconButtonWithBadge from '@/client/components/_molecules/icon_button_with_badge'
import { formatNumber } from '@/client/filters/filters'
import { useSystemStore } from '@/client/store/useSystemStore'

type SnsType = 'instagram' | 'twitter' | 'tiktok'

export default defineComponent({
  components: {
    IconButtonWithBadge
  },
  props: {
    snsType: { type: String as PropType<SnsType>, required: true },
    applicant: { type: Object as PropType<any>, required: true },
    campaignType: String,
    isDmSending: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {}
  },
  computed: {
    ...mapState(useSystemStore, {
      isEndContract: state => (state.currentGroup ? state.currentGroup.contractStatus === 3 : false)
    }),

    /**
     * NGアカウントのツールチップコンテンツ
     */
    ngTooltipContent(): string {
      return this.applicant.isNg === 1 ? 'NGアカウントを解除' : 'NGアカウントに追加'
    }
  },
  methods: {
    formatNumber,

    /**
     * 当選者フラグのツールチップコンテンツ
     */
    winnerTooltipContent() {
      if (this.isDmSending) {
        return 'DM送信中のため変更できません'
      }

      return this.applicant.isWinner === 1 ? '当選者を解除' : '当選者に追加'
    },

    /**
     * メッセージ配信履歴を開く
     * @param {number} applicantId
     */
    openMessageHistory(applicantId: number) {
      this.$emit('open_message_history', {
        applicantId
      })
    },

    /**
     * NGアカウント追加/解除
     */
    changeNg() {
      this.$emit('change_ng', {
        screenName: this.applicant.screenName,
        isNg: this.applicant.isNg === 0,
        ngApplicantId: this.applicant.ngApplicantId ?? null
      })
    },

    /**
     * フラグ変更処理
     * @param {string} type
     */
    updateFlg(type: string) {
      const payload = {
        type,
        value: {}
      }

      switch (type) {
        case 'winner':
          payload.value = {
            applicantId: this.applicant.id,
            isWinner: this.applicant.isWinner === 0 ? 1 : 0,
            wasWinner: 1
          }
          break
        case 'responder':
          payload.value = {
            applicantId: this.applicant.id,
            isResponder: this.applicant.isResponder === 0 ? 1 : 0
          }
          break
        case 'candidate':
          payload.value = {
            applicantId: this.applicant.id,
            isCandidate: this.applicant.isCandidate === 0 ? 1 : 0
          }
          break
        case 'follower':
          payload.value = {
            applicantId: this.applicant.id,
            isFollowing: this.applicant.isFollowing === 0 ? 1 : 0
          }
          break
        case 'winnerContact':
          payload.value = {
            applicantId: this.applicant.id,
            isWinnerContact: this.applicant.isWinnerContact === 0 ? 1 : 0
          }
          break
      }

      this.$emit('change_flag', payload)
    }
  }
})
</script>
